import {
  type HttpEvent,
  type HttpHandlerFn,
  type HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { StorageService } from '../services/storage/storage.service';

// Endpoints that require authentication
const AUTH_ENDPOINTS = [
  '/shipping-cost',
  '/store-branches',
  '/store-payments',
  '/store-user-addresses',
  '/store-user-orders',
  '/store-users',
  '/coupons/validate',
];

export function tokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const storage = inject(StorageService);

  const token =
    storage.getItem<string>(
      environment.localStorageKeys.accessToken,
      'local',
    ) ||
    storage.getItem<string>(
      environment.localStorageKeys.accessToken,
      'session',
    );

  const requiresAuth = AUTH_ENDPOINTS.some((endpoint) =>
    req.url.includes(endpoint),
  );

  if (token && requiresAuth) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(authReq);
  }

  return next(req);
}
